import {
  FETCH_OFFERS_FAILURE,
  FETCH_OFFERS_SUCCESS,
  RESET_SELECTED_OFFER,
  UPDATE_OFFER_DISCOUNT_SUCCESS,
  UPDATE_OFFER_REWARD_SUCCESS,
} from 'constants/offers';
import { SET_LOCALE } from 'constants/ui';
import type {
  OfferDiscount,
  OfferReward,
  SingleOfferWithIds,
} from 'models/offer';
import { combineReducers } from 'redux';

type OffersAction =
  | {
      type: typeof FETCH_OFFERS_SUCCESS;
      payload: {
        entities:
          | {
              offers: Record<string, SingleOfferWithIds>;
            }
          | Record<string, unknown>;
        result: string[];
      };
    }
  | {
      type: typeof UPDATE_OFFER_DISCOUNT_SUCCESS;
      payload: { offerId: string; discount: OfferDiscount | null };
    }
  | {
      type: typeof UPDATE_OFFER_REWARD_SUCCESS;
      payload: { offerId: string; reward: OfferReward | null };
    }
  | { type: typeof FETCH_OFFERS_FAILURE }
  | { type: typeof RESET_SELECTED_OFFER | typeof SET_LOCALE };

export const byId = (
  state: Record<string, object> = {},
  action: OffersAction,
) => {
  switch (action.type) {
    case FETCH_OFFERS_SUCCESS:
      const { entities: { offers = {} } = {} } = action.payload;

      return offers;
    case FETCH_OFFERS_FAILURE:
      return {};
    case UPDATE_OFFER_DISCOUNT_SUCCESS: {
      const { offerId, discount } = action.payload;

      return { ...state, [offerId]: { ...state[offerId], discount } };
    }
    case UPDATE_OFFER_REWARD_SUCCESS: {
      const { offerId, reward } = action.payload;

      return { ...state, [offerId]: { ...state[offerId], reward } };
    }
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: OffersAction) => {
  switch (action.type) {
    case FETCH_OFFERS_SUCCESS:
      const { result: offerIds = [] } = action.payload;
      return offerIds;
    case FETCH_OFFERS_FAILURE:
      return [];
    default:
      return state;
  }
};

export const didInvalidate = (state = false, action: OffersAction) => {
  switch (action.type) {
    case RESET_SELECTED_OFFER:
    case SET_LOCALE:
    case FETCH_OFFERS_FAILURE:
      return true;
    case FETCH_OFFERS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const offers = combineReducers({ byId, ids, didInvalidate });

export { offers };
